(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kz-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pushEvent = (eventName, payload) => {
      if (!eventName) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        event_source: 'kz_hero',
        page_path: window.location.pathname,
        page_title: document.title,
        ...payload,
      });
    };

    const bindHero = (hero) => {
      if (!hero || hero.dataset.kzHeroTrackingBound === 'true') return;

      hero.dataset.kzHeroTrackingBound = 'true';

      const context = hero.dataset.trackingContext;
      const ctaEvent = hero.dataset.trackingCtaEvent;
      const targetId = hero.dataset.trackingTargetId;
      const targetEvent = hero.dataset.trackingTargetEvent;
      const cta = hero.querySelector('[data-kz-hero-cta]');

      if (cta && ctaEvent) {
        cta.addEventListener('click', () => {
          pushEvent(ctaEvent, {
            section_id: hero.id,
            ...(context ? { tracking_context: context } : {}),
            cta_label: cta.textContent.replace(/\s+/g, ' ').trim(),
            cta_destination: cta.getAttribute('href'),
          });
        });
      }

      if (!targetId || !targetEvent || !('IntersectionObserver' in window)) return;

      const target = document.getElementById(targetId);
      if (!target) return;

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          pushEvent(targetEvent, {
            section_id: target.id,
            source_section_id: hero.id,
            ...(context ? { tracking_context: context } : {}),
          });
          observer.disconnect();
        },
        { threshold: 0.5 },
      );

      observer.observe(target);
    };

    const initializeHeroes = (root = document) => {
      if (root.matches?.('[data-kz-hero]')) bindHero(root);
      root.querySelectorAll('[data-kz-hero]').forEach(bindHero);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeHeroes());
    } else {
      initializeHeroes();
    }

    document.addEventListener('shopify:section:load', (event) => initializeHeroes(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vector-systems-access-hero"]) return;
  try {
    

let heroText = $('.vsa-hero p').html();

let firstParagraph = heroText.substring( 160, heroText.indexOf('<br>') );

if ( window.innerWidth <= 601 ) {
  $('.vsa-hero p').html(firstParagraph + "..");
} else {
  $('.vsa-hero p').html(heroText);
}

$('.show-hide-description-button').click(function(){
  $(this).toggleClass('less');

  if ( $('.show-hide-description-button.less').length > 0 ) {
    $('.show-hide-description-button').html('SHOW LESS');
    $('.vsa-hero p').html(heroText);
  } else {
    $('.show-hide-description-button').html('SHOW MORE');
    $('.vsa-hero p').html(firstParagraph + "..");
  }

})

$(window).resize(function() {
  if ( window.innerWidth <= 601 && $('.show-hide-description-button.less').length <= 0 ) {
    $('.vsa-hero p').html(firstParagraph + "..");
  } else {
    $('.vsa-hero p').html(heroText);
  }
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vector-systems-access-systems"]) return;
  try {
    

$().ready(function() {
    $('.tab').click(function() {
        $('.tab').addClass('disable-tab');
        $(this).removeClass('disable-tab');

        let showTab = $(this).data('tab-name');

        $('.tab-card').addClass('hide');

        $(`.tab-card[data-tab="${showTab}"]`).removeClass('hide');
    })
});


  } catch(e) { console.error(e); }
})();
})();
